import { render, staticRenderFns } from "./BidApplyDetail.vue?vue&type=template&id=975a3996&scoped=true"
import script from "./BidApplyDetail.vue?vue&type=script&lang=js"
export * from "./BidApplyDetail.vue?vue&type=script&lang=js"
import style0 from "./BidApplyDetail.vue?vue&type=style&index=0&id=975a3996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975a3996",
  null
  
)

export default component.exports